//@flow
import React, {Component} from 'react';
import {ScrollView, StyleSheet, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import {ConfirmationModal, HoshiInput, Icon} from '../../components/common';
import type {FormProps} from 'redux-form';
import {Field} from 'redux-form';
import I18n from '../../lib/i18n';
import config from '../../config';
import {isCurrencyPlaceOnRight} from './lib';
import theme from '../../theme-config';
import * as Navigation from '../../lib/navigation.js';

export default class AddMoneyWithCreditCard extends Component<Props> {
  styles = getStyles();

  goToNewPaymentMeanPage = () =>
    Navigation.navigate('registerPaymentDetails', {
      redirectTo: 'newPaymentMean',
    });

  render() {
    const styles = this.styles;
    const {
      amount,
      amountPlaceholder,
      confirmText,
      currentBalanceText,
      getModalBody,
      handleSubmit,
      iconName,
      invalid,
      isLoading,
    } = this.props;
    const nullSafeAmount = amount?.amount || '0';

    const inputContainerStyle = [
      styles.inputContainer,
      isCurrencyPlaceOnRight() && styles.reverseInputContainer,
    ];
    const isFormInvalid = !amount || invalid;

    return (
      <ScrollView style={styles.container}>
        <View style={styles.description}>
          {iconName && (
            <Icon name={iconName} size={40} color={theme.secondaryColor} />
          )}
          <Text style={[styles.text, styles.currentBalance]}>
            {currentBalanceText}
          </Text>
          <View style={inputContainerStyle}>
            <Text style={styles.currency}>{config.currency}</Text>
            <Field
              autoFocus
              placeholder={amountPlaceholder || ''}
              name="amount"
              component={HoshiInput}
              returnKeyType="go"
              onSubmitEditing={handleSubmit}
              style={styles.input}
              inputStyle={styles.inputStyle}
              errorStyle={styles.errorStyle}
              errorNumberOfLines={2}
              wrapperContainerStyle={styles.inputWrapperContainer}
              type="digits"
              validateWhileTyping
            />
          </View>
        </View>
        <ConfirmationModal
          confirmContent={getModalBody(nullSafeAmount)}
          onConfirm={handleSubmit}
          openModalText={confirmText}
          disabled={isFormInvalid}
          thirdButtonAction={this.goToNewPaymentMeanPage}
          thirdButtonText={I18n.t('SignUp.ConfirmPlan.modal.thirdButtonText')}
          isLoading={isLoading}
        />
      </ScrollView>
    );
  }
}

type Props = FormProps &
  StateProps &
  DispatchProps & {
    iconName?: string,
    currentBalanceText: string,
    confirmText: string,
    amountPlaceholder?: string,
  };

export type StateProps = {
  isLoading: boolean,
};

export type DispatchProps = {
  onSubmit: Function,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.backgroundColor,
      paddingHorizontal: 13,
    },
    reverseInputContainer: {
      flexDirection: 'row-reverse',
    },
    description: {
      alignItems: 'center',
      marginTop: 20,
      marginBottom: 10,
    },
    text: {
      textAlign: 'center',
      color: theme.defaultTextColor,
    },
    currentBalance: {
      marginTop: 25,
      marginBottom: 25,
      fontSize: 18,
    },
    inputContainer: {
      alignSelf: 'stretch',
      flexDirection: 'row',
      alignItems: 'center',
      marginHorizontal: 35,
      marginBottom: 40,
    },
    currency: {
      fontSize: 40,
      marginRight: 20,
    },
    inputWrapperContainer: {
      flexGrow: 1,
      marginLeft: 10,
    },
    input: {
      alignSelf: 'stretch',
    },
    inputStyle: {
      height: 70,
      fontSize: 40,
      paddingVertical: 0,
    },
    errorStyle: {
      maxWidth: 200,
      marginTop: 5,
      textAlign: 'center',
      alignSelf: 'center',
    },
  });
